module.exports = __webpack_public_path__ + "img/Update-V1840.c810ecb4.webp";